import { loadDataMaps, loadDataMap, loadDataMapSamples } from 'js/actions/dataMaps';
import { useDispatch, useSelector } from 'react-redux';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_ALL_DATA_MAPS_REQUEST, GET_DATA_MAP_REQUEST } from 'js/constants/actionTypes';
import { useCallback } from 'react';

type UseDataMaps = {
  dataMaps: any;
  dataMapIds: any;
  dataMapSamples: any;
  dataMapsLastUpdated: any;

  fetchDataMap(...args: any): void;
  fetchDataMaps(...args: any): void;
  fetchDataMapSamples(...args: any): void;
};
export function useDataMaps() {
  const dispatch = useDispatch<any>();
  const isLoadingDataMaps = useIsLoading(GET_DATA_MAP_REQUEST, GET_ALL_DATA_MAPS_REQUEST);
  const dataMaps = useSelector((s: any) => s.entities.dataMaps);
  const {
    byId: dataMapIds,
    samplesById: dataMapSamples,
    lastUpdated: dataMapsLastUpdated,
  } = useSelector((s: any) => s.dataMaps);

  const fetchDataMaps = useCallback((...args: any) => dispatch(loadDataMaps(...args)), []);

  const fetchDataMap = useCallback((...args: any) => dispatch(loadDataMap(...args)), []);

  const fetchDataMapSamples = useCallback(
    (id = -1, page = 1, perPage = 10) => dispatch(loadDataMapSamples(id, page, perPage)),
    [],
  );

  return {
    isLoadingDataMaps,
    dataMaps,
    dataMapIds,
    dataMapSamples,
    dataMapsLastUpdated,
    // actions
    fetchDataMap,
    fetchDataMaps,
    fetchDataMapSamples,
  };
}
